export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M9 18v-2H3v2zM3 8h18V6H3zm12 5v-2H3v2z\"/>"
};